<div class="modal-header">
  <div class="modal-header-title">High-Five</div>
  <cross (click)="closeModal()"></cross>
</div>

<div class="modal-body">
  @if (!dataLoaded) {
  <spinner></spinner>
  } @if (dataLoaded) {

  <div class="row subject">
    <a360-avatar [originalSrc]="highFive.Subject.AvatarSrc" [altDescription]="highFive.Subject.FullName"></a360-avatar>
    <div class="full-name">{{ highFive.Subject.FullName }}</div>
  </div>
  <div class="row description">{{ highFive.Description }}</div>
  <div class="row info">Reported by {{ highFive.CreatorFullName }}, {{ highFive.WorkDate | agencyDate }}</div>
  @if (highFive.OtherSubjects.length) {
  <div class="row info">Other recipient(s): {{ otherSubjectsText }}</div>
  } }
</div>

@if (dataLoaded) {
<div class="modal-footer">
  <div class="buttons-box">
    <button class="fto-legacy-btn btn btn-primary" type="button" (click)="closeModal()">Close</button>
  </div>
</div>
}
